// import * as PostMessage from "postmessage";
import CurrierBase from "./CurrierBase";

const postMessage = (message, origin, target) => {
  if (!target.postMessage) return;
  target.postMessage(message, origin);
};
// console.log('postMessage', PostMessage)
// const { receiveMessage, postMessage} = PostMessage;
// const PostMessage = {receiveMessage:(e)=>{}, postMessage:(e)=>{}}

export class IframeCurrier extends CurrierBase {
  constructor() {
    super();
  }

  // initialization
  onRegister(messengerHub) {
    super.onRegister(messengerHub);

    this.messengerHub = messengerHub;

    // listen for incoming messages
    window.addEventListener("message", (event) => {
      // if there's no source then its likely a message from an extension
      if (!event.source) return;

      // now repeat this to everyone except the originator
      this.sendUp(event.data, event.source);
      this.sendDown(event.data, event.source);

      this.receiveMessage(event.data);
    });
  }

  // send up refers to parent window, send down refers to child iframes
  onSendMessage(packagedMessage) {
    // send to each of our iframes
    // we package these as json for older browsers
    // look downward
    this.sendDown(packagedMessage);

    // now look up!
    this.sendUp(packagedMessage);
  }

  // these are broken out for use elsewhere
  sendUp(packagedMessage, exclude = null) {
    // this is to stop an infinite feedback loop
    if (window.parent != window && !(exclude && exclude == window.parent)) {
      postMessage(packagedMessage, "*", window.parent);
    }
  }

  // loop through window.frames and send to each one
  sendDown(packagedMessage, exclude = null) {
    for (let i = 0; i < window.frames.length; i++) {
      // this is to stop an infinite feedback loop
      if (!(exclude && exclude == window.frames[i])) {
        postMessage(packagedMessage, "*", window.frames[i]);
      }
    }
  }

  // we have to stringify the message
  // for old browsers that will resort to urls
  packMessage(message, systemMessage = null) {
    return JSON.stringify(message);
  }

  // here we extract and handle the system message
  unpackMessage(packagedMessage) {
    try {
      let parsedPackage = JSON.parse(packagedMessage);
      // console.log("packedMessage", packagedMessage);
      if (!parsedPackage.channel) return null;
      return parsedPackage;
    } catch (e) {
      // console.log("unpacking in iframe currier", packagedMessage);
      return null;
    }
  }
}

export default IframeCurrier;
